import { z } from 'zod'

import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

export const [PaymentRequiredStatuses, PaymentRequiredStatusSchema] =
  EnumBuilder('queued')

export const PaymentRequiredSchema = z.object({
  jobId: z.string(),
  status: PaymentRequiredStatusSchema,
})

export type PaymentRequired = ZodInfer<typeof PaymentRequiredSchema>
